import * as React from 'react';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { AllCollectionsSpaceAngularProps, AllCollectionsSpaceOwnProps } from './AllCollectionsSpace';
import { ConnectedAllCollectionsSpace } from './ConnectedAllCollectionsSpace';

export interface AllCollectionsSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const AllCollectionsSpaceAngularHOC = angularProviderHOC<AllCollectionsSpaceOwnProps, AllCollectionsSpaceAngularProps, AllCollectionsSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    browserTitleService: ServiceLocator.get<BrowserTitleService>('BrowserTitleService'),
    telemetry: ServiceLocator.get<Telemetry>('TelemetryService'),
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedAllCollectionsSpace: React.ComponentType<AllCollectionsSpaceOwnProps>
  = AllCollectionsSpaceAngularHOC(ConnectedAllCollectionsSpace);

const AllCollectionsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'collections',
  subspaceName: undefined
};

export const AllCollectionsSpaceProvider: React.FunctionComponent<AllCollectionsSpaceProviderProps> = (props) => {

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllCollectionsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <AngularWrappedAllCollectionsSpace angularContext={props.angularContext} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
